import { User, Loader2 } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { cn } from '@/lib/utils';
import { useUserAvatar } from '../hooks';

interface UserAvatarProps {
  userId: number;
  name: string;
  className?: string;
}

/**
 * Компонент для отображения аватарки пользователя Telegram
 * Загружает аватарку по Telegram ID пользователя, в fallback показывает инициалы
 */
export function UserAvatar({ userId, name, className }: UserAvatarProps) {
  const initials = name
    .split(' ')
    .slice(0, 2)
    .map(word => word.charAt(0).toUpperCase())
    .join('');

  const { url, isLoading } = useUserAvatar(userId);

  // Если нет аватарки и не загружается - сразу показываем fallback
  if (!url && !isLoading) {
    return (
      <Avatar className={cn('flex-shrink-0 bg-primary/10', className)}>
        <AvatarFallback className="bg-primary/10 text-primary font-semibold text-xs">
          {initials || <User className="h-3 w-3" />}
        </AvatarFallback>
      </Avatar>
    );
  }

  return (
    <Avatar className={cn('flex-shrink-0', className)}>
      {isLoading && (
        <div className="w-full h-full flex items-center justify-center bg-primary/10">
          <Loader2 className="h-3 w-3 animate-spin text-primary" />
        </div>
      )}
      {url && (
        <>
          <AvatarImage src={url} alt={name} />
          <AvatarFallback className="bg-primary/10 text-primary font-semibold text-xs">
            {initials || <User className="h-3 w-3" />}
          </AvatarFallback>
        </>
      )}
    </Avatar>
  );
}
